import React, { useContext, useEffect, useState } from "react";
import ReportContext from "../../context/500/ReportContext";
import ReportPerYear from "./ReportPerYear";
import CourseAssignmentContext from "../../context/500/CourseAssignmentContext";
import { CircularProgress } from "@mui/material";

function ReportMainLayout() {
  let {
    getCourseReport,
    ownassignmentcourses,
    otherDeptassignmentcourses,
    reqassignmentcourses,
    dataOfGeneral,
    admissionForReport,
    programForReport,
    loading,
    setLoading,
    filterReportResult,
  } = useContext(ReportContext);

  let { staffs } = useContext(CourseAssignmentContext);

  let [showDetailsof, setshowDetailsof] = useState("own");
  let [isMounted, setIsMounted] = useState(true);

  useEffect(() => {
    filterReportResult();
  }, [
    admissionForReport,
    programForReport,
    ownassignmentcourses,
    reqassignmentcourses,
    otherDeptassignmentcourses,
  ]);

  useEffect(() => {
    setLoading(true);
    setIsMounted(true);

    const controller = new AbortController();
    getCourseReport(isMounted, controller.signal);
    setLoading(false);
    setshowDetailsof("own");

    return () => {
      setIsMounted(false);
      controller.abort();
    };
  }, []);

  useEffect(() => {
    getCourseReport(true);
  }, [staffs]);

  return (
    <React.Fragment>
      {loading === false ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            marginBottom: "10px",
          }}
        >
          <div className="general-report-for-all">
            <h3 style={{ textAlign: "center" }}>Activities</h3>

            <div className="general-assignment-wrapper">
              <div
                className="assignment"
                style={{
                  backgroundColor:
                    showDetailsof === "own" ? "lightgray" : "white",
                }}
                onClick={() => {
                  setshowDetailsof("own");
                }}
              >
                <div
                  style={{
                    width: "100%",
                    fontSize: "13px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <span style={{ marginLeft: "15px" }}>Own Assignment</span>
                  <span style={{ marginRight: "15px" }}>
                    {dataOfGeneral.own.total === 0
                      ? "100%"
                      : Math.round(
                          (
                            ((dataOfGeneral.own.total -
                              dataOfGeneral.own.unassignednum) *
                              100) /
                            dataOfGeneral.own.total
                          ).toString()
                        ) + "%"}
                  </span>
                </div>
                <div
                  style={{
                    width: "100%",
                    backgroundColor:
                      showDetailsof === "own" ? " ghostwhite" : "lightgray",
                    height: "10px",
                    borderRadius: "15px",
                  }}
                >
                  <div
                    className="progress-bar"
                    style={{
                      width:
                        dataOfGeneral.own.total === 0
                          ? "100%"
                          : (
                              ((dataOfGeneral.own.total -
                                dataOfGeneral.own.unassignednum) *
                                100) /
                              dataOfGeneral.own.total
                            ).toString() + "%",
                      height: "99%",
                      minWidth: "5%",
                      borderRadius: "15px",
                      backgroundColor: "darkblue",
                    }}
                  ></div>
                </div>
              </div>

              <div
                className="assignment"
                style={{
                  backgroundColor:
                    showDetailsof === "req" ? "lightgray" : "white",
                }}
                onClick={() => {
                  setshowDetailsof("req");
                }}
              >
                <div
                  style={{
                    width: "100%",
                    fontSize: "13px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <span style={{ marginLeft: "15px" }}>Requested Courses </span>
                  <span style={{ marginRight: "15px" }}>
                    {dataOfGeneral.req.total === 0
                      ? "100%"
                      : Math.round(
                          (
                            ((dataOfGeneral.req.total -
                              dataOfGeneral.req.unassignednum) *
                              100) /
                            dataOfGeneral.req.total
                          ).toString()
                        ) + "%"}
                  </span>
                </div>
                <div
                  style={{
                    width: "100%",
                    backgroundColor:
                      showDetailsof === "req" ? " ghostwhite" : "lightgray",
                    height: "10px",
                    borderRadius: "15px",
                  }}
                >
                  <div
                    className="progress-bar"
                    style={{
                      width:
                        dataOfGeneral.req.total === 0
                          ? "100%"
                          : (
                              ((dataOfGeneral.req.total -
                                dataOfGeneral.req.unassignednum) *
                                100) /
                              dataOfGeneral.req.total
                            ).toString() + "%",
                      height: "99%",
                      minWidth: "5%",
                      borderRadius: "15px",
                      backgroundColor: "#f9922c",
                    }}
                  ></div>
                </div>
              </div>

              <div
                className="assignment"
                style={{
                  backgroundColor:
                    showDetailsof === "other" ? "lightgray" : "white",
                  marginBottom: "10px",
                }}
                onClick={() => {
                  setshowDetailsof("other");
                }}
              >
                <div
                  style={{
                    width: "100%",
                    fontSize: "13px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",

                    marginBottom: "8px",
                  }}
                >
                  <span style={{ marginLeft: "15px" }}>
                    Other department Assignment
                  </span>
                  <span style={{ marginRight: "15px" }}>
                    {dataOfGeneral.other.total === 0
                      ? "100%"
                      : Math.round(
                          (
                            ((dataOfGeneral.other.total -
                              dataOfGeneral.other.unassignednum) *
                              100) /
                            dataOfGeneral.other.total
                          ).toString()
                        ) + "%"}
                  </span>
                </div>
                <div
                  style={{
                    width: "100%",
                    backgroundColor:
                      showDetailsof === "other"
                        ? " ghostwhite"
                        : "rgb(230, 230, 230)",
                    height: "10px",
                    borderRadius: "15px",
                  }}
                >
                  <div
                    className="progress-bar"
                    style={{
                      width:
                        dataOfGeneral.other.total === 0
                          ? "100%"
                          : (
                              ((dataOfGeneral.other.total -
                                dataOfGeneral.other.unassignednum) *
                                100) /
                              dataOfGeneral.other.total
                            ).toString() + "%",
                      height: "99%",
                      minWidth: "5%",
                      borderRadius: "15px",
                      backgroundColor: "rgb(108, 108, 108)",
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <ReportPerYear showDetailsof={showDetailsof} />
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            marginBottom: "10px",
          }}
        >
          <CircularProgress />
        </div>
      )}
    </React.Fragment>
  );
}

export default ReportMainLayout;
